/** @format */

import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router'
// import { Menu, MenuItem } from 'kpc-react/components/menu'
import { Aside } from 'kpc-react/components/layout'
import { Menu, MenuItem, MenuTitle, ConfigProvider, Divider } from '@king-design/react'
import styled from 'styled-components'
import { _$ } from 'kpc-react'
import useGlobalData from 'src/hooks/useGlobalData'
const RouterBar = props => {
  const productMenu = useGlobalData('productMenu')
  const path = props.location.pathname
  // 主题色
  const [theme, setTheme] = useState<'light' | 'dark' | 'white'>('light')
  // 选中菜单
  const [key, setKey] = useState<string | undefined>()
  // 展开菜单
  const [expandedKeys, setexpandedKeys] = useState<string[]>([])
  useEffect(() => {
    if (path.indexOf('/monitor/list/overview/') >= 0 || path.indexOf('/monitor/list/') >= 0) {
      setKey('/monitor/menu')
    } else {
      setKey(undefined)
    }
  }, [path])

  useEffect(() => {
    let windowRegion
    window['__ksStorage__'].on('theme', data => {
      setTheme(data)
    })
    return () => {
      windowRegion && windowRegion.remove()
    }
  }, [])

  return (
    <div className={props.className}>
      {productMenu?.length ? (
        <ConfigProvider value={{ classNamePrefix: 'kd' }}>
          <Menu
            size="small"
            slotHeader={<>{_$('云监控')}</>}
            onChangeCollapse={val => {
              props.setMenuState(val)
            }}
            expandedKeys={expandedKeys}
            onChangeExpandedKeys={expandedKeys => setexpandedKeys(expandedKeys)}
            selectedKey={key || props.location.pathname}
            collapse={props.menuState}
            showCollapseArrow={true}
            theme={theme}
          >
            <MenuItem key="/monitor/generalview/home" to="/monitor/generalview/home">
              概览
            </MenuItem>
            <MenuItem key="/monitor/menu" to="/monitor/menu">
              云产品监控
            </MenuItem>
            <MenuTitle>自定义监控</MenuTitle>
            <MenuItem key="/monitor/custom/metric" to="/monitor/custom/metric">
              指标
            </MenuItem>
            <MenuItem key="/monitor/custom/alarm" to="/monitor/custom/alarm">
              警报
            </MenuItem>
            <MenuTitle>告警服务</MenuTitle>
            <MenuItem key="/monitor/alarmServer/rule/home" to="/monitor/alarmServer/rule/home">
              告警策略
            </MenuItem>
            <MenuItem
              key="/monitor/alarmServer/history/home"
              to="/monitor/alarmServer/history/home"
            >
              告警历史
            </MenuItem>
            <MenuItem
              key="/monitor/alarmServer/alarming/home"
              to="/monitor/alarmServer/alarming/home"
            >
              正在告警
            </MenuItem>
            <Divider className="divider-style" theme={theme === 'white' ? 'light' : theme} />
            <MenuItem key="/monitor/systomcenter/home" to="/monitor/systomcenter/home">
              事件中心
            </MenuItem>
            <MenuItem key="/monitor/dashboard/home" to="/monitor/dashboard/home">
              Dashboard
            </MenuItem>
            <MenuItem key="/monitor/group/home" to="/monitor/group/home">
              资源分组
            </MenuItem>
            <MenuItem key="/monitor/linkman/home" to="/monitor/linkman/home">
              联系人管理
            </MenuItem>
          </Menu>
        </ConfigProvider>
      ) : null}
    </div>
  )
}
const SiderBar = withRouter(RouterBar)
export default styled(SiderBar)`
  padding-top: 50px;
  position: fixed;
  top: 0;
  height: 100vh;
  background: #fff;
  .kd-menu {
    border-bottom: none;
    height: 100%;
  }
  .divider-style {
    margin: 4px 0;
  }
`
